import React from 'react';

function NoResults() {
  return <div className="project-status-grid-item__no-results">No Results</div>;
}

export default NoResults;
